import { formatPhoneNumber } from '@strata/helper-functions';
import { FormSectionWithRows } from '@strata/react-form-section';
import { DetailLabelList, DetailLabelValuePair } from '@strata/react-label-value-pairs';
import PropTypes from 'prop-types';

import {
    addQtyUnits,
    getEstDispensedQtyUnits,
    PreferredBillingTypes,
    useProductConfig,
} from 'services/ProductConfigHelpers';

export const PrescribingInfo = ({ referralDetails = undefined }) => {
    const productConfig = useProductConfig({
        segmentId: referralDetails?.segmentId,
        productServiceOid: referralDetails?.productServiceOid,
        benefit: referralDetails?.benefit,
    });

    return (
        <FormSectionWithRows
            sectionTitle="Prescribing Information"
            isLoading={!referralDetails}
            rowOneContent={
                <>
                    <DetailLabelValuePair
                        style={{ width: '18.5%' }}
                        label="Medication"
                        value={referralDetails?.medication}
                    />
                    <DetailLabelValuePair
                        style={{ width: '18.5%' }}
                        label="Strength"
                        value={referralDetails?.strength}
                    />
                    <DetailLabelValuePair
                        style={{ width: '18.5%' }}
                        label="Estimated Quantity"
                        value={addQtyUnits(
                            referralDetails?.quantity,
                            getEstDispensedQtyUnits(productConfig),
                        )}
                    />
                    <DetailLabelValuePair
                        style={{ width: '18.5%' }}
                        label="Refills"
                        value={referralDetails?.refills}
                    />
                </>
            }
            rowTwoContent={
                <>
                    <DetailLabelValuePair
                        style={{ width: '18.5%' }}
                        label="Directions"
                        value={referralDetails?.directions}
                    />
                    <DetailLabelValuePair
                        style={{ width: '18.5%' }}
                        label="Special Instructions"
                        value={referralDetails?.specialInstructions}
                    />
                    <DetailLabelValuePair
                        style={{ width: '18.5%' }}
                        label="Point Of Contact"
                        value={referralDetails?.clinicalInfo?.pointOfContact}
                    />
                    <DetailLabelValuePair
                        style={{ width: '18.5%' }}
                        label="Point Of Contact Phone"
                        value={formatPhoneNumber(
                            referralDetails?.clinicalInfo?.pointOfContactPhone,
                        )}
                    />
                    {referralDetails?.clinicalInfo?.additionalMedications?.length > 0 && (
                        <DetailLabelList
                            style={{ width: '25%' }}
                            label="Additional Medications"
                            values={referralDetails.clinicalInfo.additionalMedications}
                        />
                    )}
                </>
            }
        />
    );
};

PrescribingInfo.propTypes = {
    referralDetails: PropTypes.shape({
        referralId: PropTypes.string,
        payerId: PropTypes.string,
        segmentId: PropTypes.string,
        prescriberNpi: PropTypes.string,
        medication: PropTypes.string,
        productServiceOid: PropTypes.string,
        strength: PropTypes.string,
        quantity: PropTypes.number,
        refills: PropTypes.number,
        directions: PropTypes.string,
        specialInstructions: PropTypes.string,
        benefit: PropTypes.oneOf(Object.values(PreferredBillingTypes)),
        clinicalInfo: PropTypes.shape({
            pointOfContact: PropTypes.string,
            pointOfContactPhone: PropTypes.string,
            additionalMedications: PropTypes.arrayOf(PropTypes.string),
        }),
    }),
};
